import * as React from 'react';

// ICONS
import { ReactComponent as SuccessIcon } from '../assets/svg/status-success.svg';
import { ReactComponent as WarningIcon } from '../assets/svg/status-warning.svg';
import { ReactComponent as DangerIcon } from '../assets/svg/status-danger.svg';
import { ReactComponent as ArchivedIcon } from '../assets/svg/status-archived.svg';
import { ReactComponent as ReadIcon } from '../assets/svg/status-read.svg';
import { ReactComponent as TodoIcon } from '../assets/svg/status-todo.svg';
import { ReactComponent as TrainingPlusIcon } from '../assets/svg/status-training-plus.svg';
import { ReactComponent as DocumentIcon } from '../assets/svg/status-document.svg';
import { ReactComponent as SchoolIcon } from '../assets/svg/status-school.svg';
import { ReactComponent as CommunityIcon } from '../assets/svg/status-community.svg';
import { ReactComponent as BusinessIcon } from '../assets/svg/status-business.svg';

interface StatusIconTypes {
	statusType: string;
}

const StatusIcon: React.FC<StatusIconTypes> = ({ statusType }) => {
	return (
		<>
			{statusType === 'success' && <SuccessIcon className="status-icon" />}
			{statusType === 'Success' && <SuccessIcon className="status-icon" />}

			{statusType === 'warning' && <WarningIcon className="status-icon" />}
			{statusType === 'Warning' && <WarningIcon className="status-icon" />}

			{statusType === 'danger' && <DangerIcon className="status-icon" />}
			{statusType === 'Error' && <DangerIcon className="status-icon" />}

			{statusType === 'archived' && <ArchivedIcon className="status-icon" />}
			{statusType === 'read' && <ReadIcon className="status-icon" />}
			{statusType === 'todo' && <TodoIcon className="status-icon" />}
			{statusType === 'training' && <TodoIcon className="status-icon" />}
			{statusType === 'training-plus' && <TrainingPlusIcon className="status-icon" />}
			{statusType === 'document' && <DocumentIcon className="status-icon" />}
			{statusType === 'school' && <SchoolIcon className="status-icon" />}
			{statusType === 'community' && <CommunityIcon className="status-icon" />}
			{statusType === 'business' && <BusinessIcon className="status-icon" />}
		</>
	);
};

export default StatusIcon;
